import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'templateMatchFilter' })
export class TemplateMatchFilterPipe implements PipeTransform {
  transform(nodes: any[], search: string, isOpened: boolean): any[] {
    if (!search || !isOpened) return nodes;
    return nodes.filter((node) => (node.title + ' ' + (node.name || '')).toLowerCase().includes(search.toLowerCase()));
  }
}
